export function dividePercentage(percentage: number) {
  if (Number.isNaN(percentage)) return 0;

  const divisions = Math.floor(percentage / 25);
  return Math.min(divisions, 4);
}
